
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upsc-prelims-previous-year-question-papers",
      function () {
        return require("private-next-pages/upsc-prelims-previous-year-question-papers/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upsc-prelims-previous-year-question-papers"])
      });
    }
  